import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';
import { getImageURL } from '../../../../../common/utils/CardUtils';
import { SweepstakesTitle } from '../../../utils/SweepstakesTitle';
import { SWEEPSTAKES_CONSTANTS } from '../../../../../core/Constants';

const { HEADER_LINE1, HEADER_LINE2, BG_IMAGE } = SWEEPSTAKES_CONSTANTS.DEFAULTS;

const HeroHeaderText = ({
  line1,
  line2,
  description,
  prizesHeading,
  isMobile,
}) => {
  const colorProp = isMobile ? 'inverse' : undefined;
  return (
    <>
      <SweepstakesTitle
        line1={line1}
        line2={line2}
        inverse={isMobile}
        variant="drawer"
        testIdPrefix="sweepstakes-hero"
      />
      {description && (
        <Typography variant="body-base" color={colorProp}>
          {description}
        </Typography>
      )}
      {prizesHeading && (
        <Typography variant="h3" weight="bold" color={colorProp}>
          {prizesHeading}
        </Typography>
      )}
    </>
  );
};

export const OptInHeroHeader = ({
  backgroundImage,
  headerLine1,
  headerLine2,
  description,
  prizesHeading,
  isMobile,
  children,
}) => {
  const raw = backgroundImage || BG_IMAGE;
  const bgSrc = raw.startsWith('http') ? raw : getImageURL(raw);
  const line1 = headerLine1 || HEADER_LINE1;
  const line2 = headerLine2 || HEADER_LINE2;

  if (!isMobile) {
    return (
      <div data-testid="sweepstakes-hero-header">
        <div className="sui-space-y-3">
          <HeroHeaderText
            line1={line1}
            line2={line2}
            description={description}
            prizesHeading={prizesHeading}
            isMobile={isMobile}
          />
        </div>
        {children && (
          <div className="sui-mt-4">
            {children}
          </div>
        )}
      </div>
    );
  }

  const mobileContainerStyle = {
    marginLeft: '-1rem',
    marginRight: '-1rem',
    marginTop: '-0.75rem',
    isolation: 'isolate',
  };

  return (
    <>
      <div
        style={mobileContainerStyle}
        className="sui-relative sui-overflow-hidden"
        data-testid="sweepstakes-hero-header"
      >
        <img
          src={bgSrc}
          alt=""
          aria-hidden="true"
          width="600"
          height="400"
          className="sui-absolute sui-inset-0 sui-w-full sui-h-full sui-object-cover sui-object-center"
        />
        <div className="sui-relative sui-z-10 sui-p-6 sui-space-y-3">
          <HeroHeaderText
            line1={line1}
            line2={line2}
            description={description}
            prizesHeading={prizesHeading}
            isMobile={isMobile}
          />
        </div>
        {children && (
          <div className="sui-relative sui-z-10 sui-px-4 sui-pb-4">
            {children}
          </div>
        )}
      </div>
    </>
  );
};

OptInHeroHeader.propTypes = {
  backgroundImage: PropTypes.string,
  headerLine1: PropTypes.string,
  headerLine2: PropTypes.string,
  description: PropTypes.string,
  prizesHeading: PropTypes.string,
  isMobile: PropTypes.bool,
  children: PropTypes.node,
};

OptInHeroHeader.defaultProps = {
  backgroundImage: null,
  headerLine1: null,
  headerLine2: null,
  description: null,
  prizesHeading: null,
  isMobile: false,
  children: null,
};
